import {Route, VueRouter} from "vue-router/types/router";
import i18n from "@/i18n";

let currentRoute: Route | undefined;
let specificTitle: string | undefined;

export function updateDocumentTitle() {
    const title = ["Food Forest Generator"];
    if (currentRoute?.name && currentRoute.name != "home" && i18n.te(`routes.${currentRoute.name}`)) {
        title.push(i18n.t(`routes.${currentRoute.name}`).toString());
    }
    if (specificTitle) {
        title.push(specificTitle);
    }
    document.title = title.join(" | ");
}

export function setSpecificTitle(title: string) {
    specificTitle = title;
    updateDocumentTitle();
}

export default function registerTitleWatcher(router: VueRouter) {
    router.beforeEach((to, from, next) => {
        currentRoute = to;
        specificTitle = undefined;
        updateDocumentTitle();
        next();
    });
}
